export function optimisticSendConversationMessageResponse({
    created,
    text,
    sender,
}: {
    created: string;
    text: string;
    sender: {id: string};
}) {
    return {
        __typename: "Mutation",
        sendConversationMessage: {
            __typename: "ChatMessage",
            id: `optimistic-${created}`,
            text,
            created,
            resolved: false,
            deleted: false,
            sender: {
                __typename: "UserField",
                id: sender.id,
            },
            isSenderBlocked: false,
            richContent: null,
        },
    };
}
